// src/components/utils/downloadXlsx.ts
import axios from "axios";
import api from "../../api/axios";

/**
 * Descarga Usuarios en XLSX
 * @param fields  array con los campos que quieres (['id','email',...])
 * @param roles   array opcional con los roles (['profesor','cliente'])
 * @param token   JWT actual, si usas auth Bearer
 * @returns blob de la respuesta para usarlo en la descarga
 */
export async function downloadUsuariosXlsx(
  fields: string[],
  roles: string[] = [],
  token: string
): Promise<Blob> {
  // Modificado para devolver un Blob
  const qs = new URLSearchParams();
  qs.set("fields", fields.join(","));
  if (roles.length) qs.set("roles", roles.join(","));

  // Asegúrate de que la URL sea completa, apuntando al puerto 3001
  const apiUrl = `http://localhost:3001/usuarios/export?${qs.toString()}`;

  try {
    const res = await axios.get(apiUrl, {
      responseType: "blob", // 👈 clave: recibimos binario
      headers: { Authorization: `Bearer ${token}` },
    });

    // Devolver el blob recibido para que sea procesado por el front
    return res.data;
  } catch (error) {
    throw new Error("Hubo un problema al generar el archivo. Intenta de nuevo.");
  }
}

export async function downloadAsignaturasXlsx(fields: string[], token: string): Promise<Blob> {
  const qs = new URLSearchParams();
  qs.set("fields", fields.join(",")); // Pasar solo los campos

  const apiUrl = `http://localhost:3001/asignaturas/export?${qs.toString()}`;

  try {
    const res = await axios.get(apiUrl, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    });

    return res.data;
  } catch (error) {
    throw new Error("Hubo un problema al generar el archivo. Intenta de nuevo.");
  }
}

/**
 * Descarga un archivo de informe usando la URL relativa del backend
 * Esta función maneja la autenticación automáticamente usando la instancia de axios configurada
 * @param url URL relativa del archivo (ej: /secure-downloads/horas-profesor-123.xlsx o /api/secure-downloads/...)
 * @param filename Nombre opcional para el archivo descargado
 */
export async function downloadReportFile(url: string, filename?: string): Promise<void> {
  try {
    // Normalizar la URL: quitar /api/ si está presente al inicio (axios ya lo añade)
    const normalizedUrl = url.startsWith("/api/") ? url.replace("/api/", "/") : url;
    
    const res = await api.get(normalizedUrl, {
      responseType: "blob",
    });

    // Crear un blob y descargarlo
    const blob = new Blob([res.data], {
      type: res.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Extraer el nombre del archivo de la URL si no se proporciona
    const finalFilename = filename || url.split("/").pop() || "download.xlsx";

    // Crear un enlace temporal y hacer clic para descargar
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = finalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Error al descargar el archivo:", error);
    throw new Error("Hubo un problema al descargar el archivo. Intenta de nuevo.");
  }
}
